var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{class:{'headerBottomLine': _vm.isShowHeaderBottomLine},attrs:{"width":_vm.dialogWidth,"title":_vm.title,"visible":_vm.visible},on:{"close":function($event){return _vm.$emit('update:visible', false)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }